export default __webpack_public_path__ + "static/media/communicate.e08fc39d.svg";